<template>
  <div class="claims-page">
    <el-card shadow="never">
      <div class="toolbar">
        <el-form :inline="true" size="small"
          ><el-form-item label="险种"
            ><el-select v-model="riskType" clearable placeholder="全部险种"
              ><el-option label="货运险" :value="1"/><el-option
                label="雇主险"
                :value="2"/></el-select></el-form-item
          ><el-form-item
            ><el-button type="primary" @click="search">搜索</el-button
            ><el-button @click="reset">重置</el-button></el-form-item
          ></el-form
        >
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openDialog()"
          >添加案件定性</el-button
        >
      </div>
      <el-table v-loading="loading" :data="rows" border stripe>
        <el-table-column label="险种" width="120"
          ><template slot-scope="scope">{{
            riskLabels[scope.row.risk_type] || "-"
          }}</template></el-table-column
        >
        <el-table-column prop="name" label="名称" min-width="180" />
        <el-table-column label="状态" width="100" align="center"
          ><template slot-scope="scope"
            ><el-tag :type="scope.row.disabled ? 'info' : 'success'">{{
              scope.row.disabled ? "已禁用" : "已启用"
            }}</el-tag></template
          ></el-table-column
        >
        <el-table-column
          prop="created_at"
          label="创建时间"
          width="180"
          :formatter="dateFormatter"
        />
        <el-table-column
          prop="updated_at"
          label="更新时间"
          width="180"
          :formatter="dateFormatter"
        />
        <el-table-column label="操作" width="140" align="center"
          ><template slot-scope="scope"
            ><el-button type="text" @click="openDialog(scope.row)"
              >编辑</el-button
            ><el-button type="text" @click="toggle(scope.row)">{{
              scope.row.disabled ? "启用" : "禁用"
            }}</el-button></template
          ></el-table-column
        >
      </el-table>
      <el-pagination
        class="pagination"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 15, 20, 25]"
        @current-change="changePage"
        @size-change="changeSize"
      />
    </el-card>
    <el-dialog
      :title="form.id ? '编辑案件定性' : '添加案件定性'"
      :visible.sync="visible"
      width="460px"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px"
        ><el-form-item label="险种" prop="risk_type"
          ><el-select v-model="form.risk_type"
            ><el-option label="货运险" :value="1"/><el-option
              label="雇主险"
              :value="2"/></el-select></el-form-item
        ><el-form-item label="定性名称" prop="name"
          ><el-input v-model.trim="form.name" maxlength="64"/></el-form-item
      ></el-form>
      <span slot="footer"
        ><el-button @click="visible = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="save"
          >保存</el-button
        ></span
      >
    </el-dialog>
  </div>
</template>

<script>
import {
  getIdentities,
  saveIdentity,
  setIdentityDisabled
} from "@/api/claims-management";
import { RISK_LABELS, formatDateTime } from "./constants";

export default {
  name: "ClaimCaseQualities",
  data() {
    return {
      loading: false,
      saving: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 15,
      riskType: "",
      riskLabels: RISK_LABELS,
      visible: false,
      form: { id: null, risk_type: 1, name: "" },
      rules: {
        risk_type: [
          { required: true, message: "请选择险种", trigger: "change" }
        ],
        name: [{ required: true, message: "请输入定性名称", trigger: "blur" }]
      }
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const params = { page: this.page, rows: this.pageSize };
        if (this.riskType) params.risk_type = this.riskType;
        const res = await getIdentities(params);
        this.rows = res.rows || [];
        this.total = Number(res.total || this.rows.length);
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.page = 1;
      this.fetchList();
    },
    reset() {
      this.riskType = "";
      this.search();
    },
    openDialog(row) {
      this.form = row
        ? { id: row.id, risk_type: Number(row.risk_type), name: row.name }
        : { id: null, risk_type: 1, name: "" };
      this.visible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const data = {
            risk_type: Number(this.form.risk_type),
            name: this.form.name
          };
          if (this.form.id) data.id = Number(this.form.id);
          await saveIdentity(data);
          this.$message.success("保存成功");
          this.visible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    toggle(row) {
      this.$confirm(
        `确认${row.disabled ? "启用" : "禁用"}“${row.name}”吗？`,
        "提示",
        { type: "warning" }
      )
        .then(async () => {
          await setIdentityDisabled({
            id: Number(row.id),
            disabled: !row.disabled
          });
          this.$message.success("修改成功");
          this.fetchList();
        })
        .catch(() => {});
    },
    dateFormatter(row, column, value) {
      return formatDateTime(value);
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.page = 1;
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.claims-page {
  padding: 20px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
